import React, { useState, useEffect } from 'react';
import { useAppInfo } from '../../hooks/useAppInfo';

export const BetaBadge = ({ style, className = '' }) => {
  const { beta } = useAppInfo();

  if (!beta) return null;

  return (
    <div className={`mb-beta-badge ${className}`.trim()} style={style}>
      <span className="mb-beta-badge__dot" aria-hidden />
      <span className="mb-beta-badge__label">Бета</span>
    </div>
  );
};

export const VersionBadge = ({ showCountdown = false }) => {
  const { version, beta, releaseDate, releaseDateFormatted, betaLaunchNote } = useAppInfo();
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!beta || !showCountdown || !releaseDate) return;

    const calculateTimeLeft = () => {
      const difference = new Date(releaseDate) - new Date();
      if (difference <= 0) return '🎉 РЕЛИЗ!';

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / 1000 / 60) % 60);

      if (days >= 1) return `${days} дн ${hours} ч ${minutes} мин`;
      
      const seconds = Math.floor((difference / 1000) % 60);
      return `${hours} ч ${minutes} мин ${seconds} сек`;
    };

    setTimeLeft(calculateTimeLeft());
    const interval = setInterval(() => setTimeLeft(calculateTimeLeft()), 1000);
    return () => clearInterval(interval);
  }, [beta, releaseDate, showCountdown]);

  if (showCountdown && beta) {
    return (
      <div className="mb-beta-countdown-wrapper">
        <div className="mb-beta-countdown__head">
          <span className="mb-beta-countdown__title">
            ⚡ БЕТА-ВЕРСИЯ v{version}
          </span>
        </div>
        <div className="mb-beta-countdown__meta">
          <div>{betaLaunchNote}</div>
          <div>Релиз: {releaseDateFormatted}, 17:00</div>
          <div className="mb-beta-countdown__countdown">
            До релиза:{' '}
            <span className="mb-beta-countdown__time">{timeLeft}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="mb-version-badge-wrap"
      title={beta ? `Релиз ${releaseDateFormatted}` : `Версия ${version}`}
    >
      <span className="mb-version-badge app-version-badge">
        v{version}{' '}
        {beta && <span className="mb-version-badge__beta">Бета</span>}
      </span>
    </div>
  );
};
